import store from "../redux/store";
import Actions from "../redux/actions";
import {
  updateQueue,
  indexQueueMedia,
  deleteQueue,
  removeQueueMedia,
  showQueue,
  addQueueMedia,
} from "./queues";
import _ from "lodash";
import { log_error } from ".";

const _updateQueue = _.debounce((options) => {
  let i = store.getState().queue.current_track_index;
  updateQueue({ current_track_index: i })
    .then(({ data }) => {
      store.dispatch(Actions.setQueue(data));
      options.resolve(fetchCurrentTrackFromCache());
    })
    .catch((error) => log_error(error));
}, 1000);
const fetchCurrentTrackFromCache = () =>
  store
    .getState()
    .queue.loaded_media.find(
      (m) =>
        m.id ===
        store.getState().queue.queue[store.getState().queue.current_track_index]
    );
const fetchCurrentTrack = async () =>
  new Promise((resolve, reject) => {
    let ret = fetchCurrentTrackFromCache();
    if (ret) resolve(ret);
    else _updateQueue({ resolve, reject });
  });
const loadNextUpOnPrev = _.debounce(async () => {
  store.dispatch(Actions.setNextUp(null));
  let {
    data: { media },
  } = await indexQueueMedia({
    queue_offset: store.getState().queue.current_track_index + 1,
  });
  store.dispatch(Actions.setNextUp(media));
  store.dispatch(Actions.setLoadingMoreNextUp(false));
}, 2000);
const loadNextUpOnNext = async () => {
  let { next_up } = store.getState();
  if (next_up && next_up.length) {
    store.dispatch(Actions.setLoadingMoreNextUp(true));
    let {
      data: { media },
    } = await indexQueueMedia({
      queue_offset: next_up.pop().queue_index,
    });
    store.dispatch(Actions.concatNextUp(media));
    store.dispatch(Actions.setLoadingMoreNextUp(false));
  }
};
const next = async () => {
  store.dispatch(Actions.setCurrentlyPlaying({ status: "fetching" }));
  store.dispatch(Actions.incrementCurrentTrackIndex());
  let current_track = await fetchCurrentTrack();
  store.dispatch(Actions.setCurrentlyPlaying(current_track));
  console.log(store.getState().playing);
  let { next_up } = store.getState();
  if (next_up && next_up.length && next_up.length <= 5) {
    loadNextUpOnNext();
  }
};
const prev = async () => {
  store.dispatch(Actions.setCurrentlyPlaying({ status: "fetching" }));
  store.dispatch(Actions.setLoadingMoreNextUp(true));
  store.dispatch(Actions.setNextUp(null));
  store.dispatch(Actions.decrementCurrentTrackIndex());
  let current_track = await fetchCurrentTrack();
  store.dispatch(Actions.setCurrentlyPlaying(current_track));
  loadNextUpOnPrev();
};
const clearQueue = async () => {
  store.dispatch(Actions.setCurrentlyPlaying({}));
  store.dispatch(Actions.setNextUp([]));
  if (!!store.current_user) {
    let { data } = await deleteQueue();
    store.dispatch(Actions.setQueue(data));
  }
};
const setCurrentlyPlaying = (value) =>
  store.dispatch(Actions.setCurrentlyPlaying(value));

// queue manipulation
const removeFromQueue = async (medium) => {
  let { queue } = store.getState();
  let queue_index =
    medium.queue_index || queue.queue.findIndex((id) => id === medium.id);
  let isCurrentlyPlaying = queue.current_track_index === queue_index;
  if (isCurrentlyPlaying)
    store.dispatch(Actions.setCurrentlyPlaying({ status: "fetching" }));
  store.dispatch(Actions.setNextUp(null));
  store.dispatch(Actions.setLoadingMoreNextUp(true));
  let { data } = await removeQueueMedia({ medium_id: medium.id });
  store.dispatch(Actions.setQueue(data));
  if (isCurrentlyPlaying)
    store.dispatch(Actions.setCurrentlyPlaying(fetchCurrentTrackFromCache()));
  loadNextUpOnPlayFromQueue();
};

const addToQueue = async (medium) => {
  store.dispatch(Actions.setNextUp(null));
  store.dispatch(Actions.setLoadingMoreNextUp(true));
  let { data } = await addQueueMedia(medium.id);
  store.dispatch(Actions.setQueue(data));
  loadNextUpOnPlayFromQueue();
};

// functions to control the player
const play = () => store.dispatch(Actions.setPlaying(true));
const pause = () => store.dispatch(Actions.setPlaying(false));
const setVolume = (percetile) => store.dispatch(Actions.setVolume(percetile));
const toggleMute = () => store.dispatch(Actions.toggleMute());
const heart = () => store.dispatch(Actions.toggleCurrentlyPlayingLikeState());
const seek = (ratio) => {
  let { player_ref, currently_playing } = store.getState();
  if (currently_playing && player_ref) player_ref.seekTo(ratio, "fraction");
};

// props
const ref = (player) => store.dispatch(Actions.setPlayerRef(player));
const onReady = () => store.dispatch(Actions.markReady());
const onProgress = (value) => store.dispatch(Actions.setProgress(value));
const onDuration = (value) => store.dispatch(Actions.setDuration(value));
const onEnded = () => {
  let { repeat, queue } = store.getState();
  if (
    !repeat &&
    queue &&
    queue.current_track_index !== queue.queue.length - 1
  ) {
    next();
    store.dispatch(Actions.setPlaying(true));
  }
};

// Ways to play media
const playMediaWithoutSource = (medium) => {
  clearQueue();
  setCurrentlyPlaying(medium);
  play();
};
const playMediaWithSource = async (medium, source) => {
  let { current_user } = store.getState();
  if (!current_user) {
    playMediaWithoutSource(medium);
    return;
  }
  store.dispatch(
    Actions.setCurrentlyPlaying({
      status: "fetching",
    })
  );
  store.dispatch(Actions.setLoadingMoreNextUp(true));
  store.dispatch(Actions.setNextUp(null));
  let { data } = await updateQueue({
    medium_id: medium.id,
    source_id: source.id,
    source_type: source.type,
    shuffle: false,
  });
  store.dispatch(Actions.setQueue(data));
  let sound_track = data.loaded_media.find((m) => m.id === medium.id);
  store.dispatch(Actions.setCurrentlyPlaying(sound_track));
  store.dispatch(Actions.setPlaying(true));
  let {
    data: { media },
  } = await indexQueueMedia({
    queue_offset: data.current_track_index + 1,
  });
  store.dispatch(Actions.setNextUp(media));
  store.dispatch(Actions.setLoadingMoreNextUp(false));
};
const loadNextUpOnPlayFromQueue = async () => {
  store.dispatch(Actions.setLoadingMoreNextUp(true));
  store.dispatch(Actions.setNextUp(null));
  let {
    data: { media },
  } = await indexQueueMedia({
    queue_offset: store.getState().queue.current_track_index + 1,
  });
  store.dispatch(Actions.setNextUp(media));
  store.dispatch(Actions.setLoadingMoreNextUp(false));
};
const playMediaFromQueue = async (medium) => {
  try {
    store.dispatch(Actions.setCurrentlyPlaying({ status: "fetching" }));
    store.dispatch(Actions.setNextUp([]));
    store.dispatch(Actions.setLoadingMoreNextUp(true));
    let { queue } = store.getState();
    let { data } = await updateQueue({
      current_track_index: queue.queue.findIndex((id) => medium.id === id),
    });
    store.dispatch(Actions.setQueue(data));
    let current_track = data.loaded_media.find(
      (m) => m.id === data.queue[data.current_track_index]
    );
    store.dispatch(Actions.setCurrentlyPlaying(current_track));
    loadNextUpOnPlayFromQueue();
    play();
  } catch (error) {
    console.log(log_error(error));
  }
};

const setCurrentlyPlayingTrack = (medium) => {
  store.dispatch(Actions.setCurrentlyPlaying(medium));
};

const updateNextQueueTrackDetails = (medium) => {
  const { next_up } = store.getState();
  const newNextUps = next_up.map((track) =>
    track.id === medium.id ? medium : track
  );
  store.dispatch(Actions.setNextUp(newNextUps));
};

const setQueueMedia = (media) => {
  store.dispatch(Actions.setQueue(media));
};

const props = {
  ref,
  onReady,
  onProgress,
  onDuration,
  onEnded,
  onPlay: play,
  onPause: pause,
};

export default {
  play,
  pause,
  next,
  prev,
  seek,
  setVolume,
  toggleMute,
  heart,
  setCurrentlyPlayingTrack,
  updateNextQueueTrackDetails,
  reactPlayerProps: props,

  loadNextUpOnNext,

  // queue manipulation
  removeFromQueue,
  addToQueue,
  setQueueMedia,

  playMediaWithoutSource,
  playMediaWithSource,
  playMediaFromQueue,
};
